import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

export enum TrgToggleSize {
  Default = '',
  Small = 'small',
};

@Component({
  selector: 'trg-toggle',
  templateUrl: './trg-toggle.component.html',
  styleUrls: ['./trg-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SharedTrgToggleComponent {
  @Input() value: boolean;
  @Output() valueChange = new EventEmitter<boolean>();

  @Input() size = TrgToggleSize.Default;
  @Input() color = '';

  @Input() disabled = false;
  @Input() readonly = false;

  @Input() onText = 'On';
  @Input() offText = 'Off';

  constructor() { }


  get isOff() {
    return Boolean(this.value) === false;
  }

  get isOn() {
    return Boolean(this.value) === true;
  }


  toggle(value?: boolean) {
    if (this.disabled || this.readonly)
      return;

    if (value === undefined) {
      value = !this.isOn;
    }
    else {
      if (value) {
        if (this.isOn) {
          return;
        }
      } else {
        if (this.isOff) {
          return;
        }
      }
    }

    this.valueChange.emit(value);
  }
}
